import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToEnquiry = () => {
    const element = document.getElementById('enquiry');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="hero-gradient"></div>
      </div>
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Transform Your Vision into
            <span className="gradient-text"> Exceptional Projects</span>
          </h1>
          <p className="hero-subtitle">
            We deliver professional project development services tailored to your business needs.
            From concept to completion, we bring your ideas to life.
          </p>
          <div className="hero-buttons">
            <button className="btn-primary" onClick={scrollToEnquiry}>
              Get Started Today
            </button>
            <button className="btn-secondary" onClick={() => document.getElementById('services')?.scrollIntoView({ behavior: 'smooth' })}>
              Our Services
            </button>
          </div>
          <div className="hero-stats">
            <div className="stat-item">
              <div className="stat-number">251+</div>
              <div className="stat-label">Projects Completed</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">150+</div>
              <div className="stat-label">Happy Clients</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">+7</div>
              <div className="stat-label">Years Experience</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
